import React, { useState } from 'react';

const EyeIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

// Input de senha com botão de mostrar/ocultar (olho). Aceita className
// (pro caso de usar uma classe CSS como .lp-input) ou style inline.
export default function PasswordInput({ className, style, value, onChange, placeholder, required, id, showLabel = 'Mostrar senha', hideLabel = 'Ocultar senha' }) {
  const [visivel, setVisivel] = useState(false);
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        id={id}
        className={className}
        style={{ ...style, paddingRight: '42px', boxSizing: 'border-box' }}
        type={visivel ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
      />
      <button
        type="button"
        onClick={() => setVisivel(v => !v)}
        aria-label={visivel ? hideLabel : showLabel}
        tabIndex={-1}
        style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', color: 'var(--text-2)' }}
      >
        {visivel ? EyeOffIcon : EyeIcon}
      </button>
    </div>
  );
}
